import { TagProps } from '@hdi-seguros/web-components.card';

import { ClaimStates } from '../../interfaces';

export const getClaimStatesTags = (states: Array<ClaimStates>): Array<TagProps> => {
    const tags: Array<TagProps> = [];

    states.forEach((state) => {
        if (state === ClaimStates.COMMERCIAL_BLOCK) {
            return tags.push({ label: 'Bloqueo comercial', color: 'red' });
        };

        if (state === ClaimStates.EMISSION_BLOCK) {
            return tags.push({ label: 'Bloqueo emisión', color: 'orange' });
        };

        if (state === ClaimStates.TECHNICAL_BLOCK) {
            return tags.push({ label: 'Bloqueo técnico', color: 'blue' });
        };

        if (state === ClaimStates.DEACTIVATED) {
            return tags.push({ label: 'Dado de baja', color: 'green' });
        };

        if (state === ClaimStates.DEACTIVATED_DUE_TO_DUPLICITY) {
            return tags.push({ label: 'Dado de baja por duplicidad', color: 'cyan' });
        };

        if (state === ClaimStates.DEACTIVATED_DUE_TO_REPLACEMENT) {
            return tags.push({ label: 'Dado de baja por reemplazo', color: 'cyan' });
        };

        if (state === ClaimStates.IN_PROCESS) {
            return tags.push({ label: 'En trámite', color: 'cyan' });
        };

        if (state === ClaimStates.LEGAL_PROCEEDINGS) {
            return tags.push({ label: 'Juicio', color: 'cyan' });
        };

        // if (state === ClaimStates.PRESCRIBED) {
        //     return tags.push({ label: 'Prescripto', color: 'cyan' });
        // };

        if (state === ClaimStates.REJECTED) {
            return tags.push({ label: 'Rechazado', color: 'cyan' });
        };

        if (state === ClaimStates.REHABILITATED) {
            return tags.push({ label: 'Rehabilitado', color: 'cyan' });
        };

        if (state === ClaimStates.COMPLETED) {
            return tags.push({ label: 'Terminado', color: 'cyan' });
        };

        return state;
    });

    return tags;
};